<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row">

                    <h1 class="mu-mb-00">Application details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Applications</a>
                    </li>
                    <li aria-current="page">Create new</li>
                </ol>
            </nav>
            <div class="mcc-card mu-p-06">
                <div class="mcc-row" v-if="!fetchCall">
                    <div class="mcc-col colSpinner">
                        <div class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col mcc-col-12">
                        <form id="formId" novalidate @submit.prevent="saveApplication()" ref="applicationCopyForm">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title  ">Details</h2>
                                </div>
                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                                <label for="name" class="mfc-label--required">Name</label>
                                                <input type="text" id="name" name="name" ref="name" :value="appDto.name" :pattern="nameRegex" @change="updateName($event)" required placeholder="Name" maxlength="50">
                                                <div class="mfc-help-text"></div>

                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                                <label for="description">Description</label>
                                                <textarea id="description" name="description" ref="description" :value="appDto.description" placeholder="Description" :pattern="descRegex" @input="appDto.description = $event.target.value" character-count="" maxlength="100"></textarea>
                                                <div class="mfc-invalid-feedback"></div><span class="mfc-help-text" v-if="appDto.description">
                                                     You have {{100 - appDto.description.length}} characters remaining
                                                </span>
                                                <span class="mfc-help-text" v-else>
                                                     You have 100 characters remaining
                                                </span>
                                            </div>
                                            <TagInput class=" mfc-form-input-wrapper--width" ref="labels" :labels="labelsNew" />
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap mu-mt-03  mfc-form-input-wrapper--width" v-for="(item, index) in filteredProcesses" :key="index">
                                                <label for="Process_name" class="mfc-label--required">Process name</label>
                                                <input type="text" name="processName" ref="processName" maxlength="50" :value="item.name" :name="getProcFieldName(index)" :id="getProcFieldName(index)" :pattern="nameRegex" @change="updateProcessName($event,index)" required="" id="Process_name">
                                                <div class="mfc-help-text"></div>

                                            </div>
                                            <div class="mt-2">
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container input-gap" id="copyDisabledProcess" name="copyDisabledProcess">
                                                    <input type="checkbox" id="disabled_Processes" class="mfc-switch" :checked="appDto.copyDisabledProcess" @change="updateDisableStatus($event)" color="primary">
                                                    <label for="disabled_Processes">Copy disabled processes</label>

                                                </div>
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container mt-2 input-gap" id="copyDisabledForm" name="copyDisabledForm">
                                                    <input type="checkbox" id="disabled_Forms" class="mfc-switch" :checked="appDto.copyDisabledForm" @change="appDto.copyDisabledForm = $event.target.checked" color="primary">
                                                    <label for="disabled_Forms">Copy disabled forms</label>

                                                </div>
                                            </div>
                                            <div class="mu-d-flex mu-justify-content-end">
                                                <router-link :to="CONTEXT_PATH + '/design/applications/' + appId">
                                                    <button class="mcc-button mcc-button--outline  mu-mr-05" id="cancelBtn" title="Cancel"  type="button">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </router-link>
                                                <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                                    <mcc-icon name="save" aria-hidden="true"></mcc-icon>
                                                    <span class="mcc-button__label">Save</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ApplicationAPI from "../../../services/ApplicationAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import TagInput from "../../common/TagInput.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage,
    checkFormAndTextareaValidations
} from "../../../formvalid"

export default {
    name: "ApplicationCopy",
    data() {
        return {
            updateCall: true,
            helpText: constantMessages.BREADCRUMB_HELP["application.copy"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            showHelpText: false,
            appDto: {
                copyDisabledProcess: false
            },
            appId: this.$route.params.appId,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            labelsNew: [],
            filteredProcesses: [],
            fetchCall: false
        };
    },
    components: {
        TagInput
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        ApplicationAPI.getCopyApplicationDetails(this.$route.params.appId)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(
                        self.CONTEXT_PATH + "/design/applications"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application"
                    });
                    return;
                }
                self.appDto = result.data;
                self.filteredProcesses = JSON.parse(JSON.stringify(self.appDto.appProcesseDTOs));

                if (result.data.labels != null) {
                    let labelArr = result.data.labels.split(",");
                    labelArr.forEach(element => {
                        self.labelsNew.push(element.trim());
                    });
                }
            })
            .finally(() => {
                self.fetchCall = true;
            });
    },
    methods: {
        saveApplication() {
            let form = $('#formId')
            let self = this;
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            
            this.appDto.labels = this.$refs.labels.value;
            let dtoRef = JSON.parse(JSON.stringify(this.appDto));
            dtoRef.appProcesseDTOs = self.filteredProcesses;
            self.updateCall = false;
            ApplicationAPI.saveApplication(
                dtoRef,
                this.appId + "/save"
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "labels") {
                            displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                            $('#tags')[0].classList.add('ms-is-invalid')
                            $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                        } else if (k.indexOf("duplicateprocess") != -1) {
                            displayErrorMessage($(self.$refs.processName[response.messages[k]]), constantMessages.MESSAGES["error.process.duplicate.add"])
                            self.$refs.processName[response.messages[k]].classList.add("ms-is-invalid")
                        } else if (k.indexOf("duplicatename") != -1) {
                            displayErrorMessage($(self.$refs.processName[response.messages[k]]), constantMessages.MESSAGES["error.process.duplicatename.add"])
                            self.$refs.processName[response.messages[k]].classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH + "/design/applications/" + response.data.id
                        )
                        .catch(err => {});
                }
            });
        },
        updateProcessName(event, fieldIndex) {
            let self = this;
            let fieldName = event.target.name;
            let field = self.$refs.processName[fieldIndex];
            if (event.target.value == "") {
                displayErrorMessage($(field), constantMessages.MESSAGES["error.processname.required"])
                field.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(field), constantMessages.MESSAGES["error.processname.50"])
                field.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(field), constantMessages.MESSAGES["error.processname.invalid"])
                field.classList.add("ms-is-invalid")
            } else {
                field.classList.remove("ms-is-invalid");
            }
            self.filteredProcesses[fieldIndex].name = event.target.value;
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid");
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.appDto.name = event.target.value;
        },
        getProcFieldName(index) {
            return "appProcesses" + index + "name";
        },
        redirectToList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        updateDisableStatus(event) {
            this.appDto.copyDisabledProcess = event.target.checked;
            let localCopy = JSON.parse(JSON.stringify(this.filteredProcesses));
            if (!this.appDto.copyDisabledProcess) {
                this.filteredProcesses = JSON.parse(JSON.stringify(this.appDto.appProcesseDTOs.filter(a => a.deletedReason == null || a.deletedReason == '')))
            } else {
                this.filteredProcesses = JSON.parse(JSON.stringify(this.appDto.appProcesseDTOs));
            }
            this.filteredProcesses.forEach(element => {
                let referenceObj = localCopy.filter(a => a.id == element.id);
                if (referenceObj.length > 0) {
                    element.name = referenceObj[0].name;
                }
            });
            this.$refs.applicationCopyForm.update();
            this.$refs.processName.forEach(element => {
                $(element).removeAttr("invalid");
            });

        }

    }
};
</script>

<style>
#labelTag .mc-tags-input__container {
    width: 40% !important;
}
</style>
